<template>
  <div>
    <plv-dialog
      :title="t('plvIA.questionnaire.setPrivacyStatement')"
      width="560px"
      custom-class="plv-ia-privacy__dialog"
      v-model="visible"
      @open="handleOptionDialog"
    >
      <div class="plv-flex-row" style="margin-bottom: 20px;">
        <plv-switch class="pws-vclass-privacy-switch"
                    :value="privacyEnabled"
                    v-bind="ynSwitchOption"
                    @change="handleEmitEnable($event);" />
        <div class="plv-ia-privacy-switch__content__tips plv-ml-16">
          <plv-icon class="plv-ia-icon-tips" icon="info-circle" />
          <span>{{tips}}</span>
        </div>
      </div>
      <plv-editor-tinymce
        ref="editor"
        v-model="privacyContent"
        height="200px"
        base-url="https://s1.videocc.net/library/tinymce/v5.10.2"
        :toolbar="toolbar"
        :tinymce-config="{
          menubar: false
        }"
        :placeholder="t('plvIA.questionnaire.privacyStatementVolume')"
      />

      <div class="plv-flex-vh-center plv-pt-20">
        <plv-button class="pws-vclass-privacy-button--primary" size="medium" @click.stop="setPrivacyContent"> {{t('plvIA.common.save')}} </plv-button>
        <plv-button
          size="medium"
          type="operate"
          class="plv-ml-20 pws-vclass-privacy-button--cancel"
          @click="visible = false"
        >
          {{t('plvIA.common.cancel')}}
        </plv-button>
      </div>
    </plv-dialog>
  </div>
</template>

<script>
import '@polyv/polyv-ui/lib-admin/theme/iconfont.css';
import '@polyv/polyv-ui/lib-admin/theme/atom-css.css';

import { Switch, Button, Dialog, Icon, EditorTinymce } from '@polyv/polyv-ui';
import { ynToBool } from '@polyv/utils/src/boolean';
import Locale from '@/mixins/locale';
export default {
  name: 'PrivacyDialog',
  components: {
    'plv-switch': Switch,
    'plv-button': Button,
    'plv-dialog': Dialog,
    'plv-icon': Icon,
    'plv-editor-tinymce': EditorTinymce
  },
  mixins: [Locale],
  props: {
    // 隐私协议是否开启
    enable: {
      type: [String, Boolean],
      default: 'N'
    },
    // 隐私协议内容
    content: {
      type: String,
      default: ''
    },

    tips: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      visible: false,
      privacyEnabled: ynToBool(this.enable),
      privacyContent: '',
      toolbar: ['link'],
    };
  },

  computed: {
    ynSwitchOption() {
      return {
        activeValue: this.enableType === 'string' ? 'Y' : true,
        inactiveValue: this.enableType === 'string' ? 'N' : false
      };
    },

    enableType() {
      return typeof this.enable === 'string' ? 'string' : 'boolean';
    },
  },

  watch: {
    content: {
      immediate: true,
      handler(val) {
        this.privacyContent = val;
      }
    },
    visible(val) {
      if (val) {
        this.privacyContent = this.content;
        this.privacyEnabled = this.enable;
      }
    }
  },
  methods: {
    setPrivacyContent() {
      this.$emit('save', {
        content: this.privacyContent,
        enable: this.privacyEnabled
      });
      this.visible = false;
    },

    handleEmitEnable(value) {
      this.privacyEnabled = value;
    },

    handleOptionDialog() {
      this.privacyContent = this.content;
    },

    ynToBool(enabled) {
      if (typeof enabled === 'boolean') return enabled;
      return ynToBool(enabled || 'N');
    }
  },
};
</script>

<style lang="scss">
.plv-ia-privacy__dialog {
  .pws-vclass-privacy-button--primary {
    background-color: var(--interactBlue) !important;
    color: #FFFFFF;
  }
  .pws-vclass-privacy-button--cancel {
    border: 1px solid #CCCCCC !important;
    color: #333333 !important;
  }
  // 隐私协议的
  .pws-vclass-privacy-switch.plv-switch--switched {
    background-color: var(--interactBlue) !important;
  }
  .pws-vclass-privacy-switch__content__button {
    color: var(--interactBlue);
    &:hover {
      color: rgba(var(--interactBlue), 0.8);
    }
  }
}
.plv-ia-privacy-switch {
  display: flex;
  align-items: center;
  // padding-top: 12px;

  & > label {
    width: 60px;
    margin-right: 8px;
  }

  & > .plv-ia-privacy-switch__content {
    flex: 1;
  }
}

.plv-ia-privacy-switch__content__tips {
  color: #757575;
  line-height: 20px;
}

.plv-ia-privacy-switch__content {
  display: flex;

  align-items: center;
}

.plv-ia-privacy-switch__content__button {
  width: 60px;
}
.plv-ia-privacy-switch__content__text {
  margin-left: 12px;
  width: 280px;
  word-break: break-all;

  p {
    display: inline;
    overflow: hidden;
    margin: 0;
    margin-top: 1px;

    text-overflow: ellipsis;
  }
}

.plv-ia-privacy-switch__content__setting {
  line-height: 20px;
}

.plv-ia-privacy-switch__preview__tip {
  color: #2196f3;
  cursor: help;
}

.plv-ia-privacy-switch__preview__image {
  width: 448px;
}

</style>
